import Seo from "../components/Seo";
import { useI18n } from "../i18n/LanguageProvider";
import { useRegisterAlternates } from "../components/layout/Layout";
import { pagePath } from "../config/pages";
import { ARTICLES } from "../data/articles";
import { PageHero, CTABand } from "../components/Sections";
import { RevealStagger, RevealItem } from "../components/motion/Reveal";
import { ArticleCard } from "../components/Cards";
import { webPageSchema, breadcrumbSchema } from "../lib/schema";

const META = {
  title: {
    en: "Dental Guides | Independent Advice for International Patients | Dentel Vietnam",
    fr: "Guides dentaires | Conseils indépendants pour patients internationaux | Dentel Vietnam",
    de: "Zahn-Ratgeber | Unabhängige Beratung für internationale Patienten | Dentel Vietnam",
  },
  desc: {
    en: "In-depth, independent dental guides for international patients considering treatment in Vietnam.",
    fr: "Des guides dentaires détaillés et indépendants pour les patients internationaux envisageant un traitement au Vietnam.",
    de: "Ausführliche, unabhängige Zahn-Ratgeber für internationale Patienten, die eine Behandlung in Vietnam erwägen.",
  },
};

export default function BlogHub() {
  const { t, lang, p } = useI18n();
  const alternates = { en: pagePath("blog", "en"), fr: pagePath("blog", "fr"), de: pagePath("blog", "de") };
  useRegisterAlternates(alternates);
  const path = pagePath("blog", lang);
  const title = t.blogSection.title;

  return (
    <>
      <Seo
        title={META.title[lang] || META.title.en}
        description={META.desc[lang] || META.desc.en}
        path={path}
        alternates={alternates}
        lang={lang}
        jsonLd={[
          webPageSchema({ name: title, description: META.desc[lang] || META.desc.en, path }),
          breadcrumbSchema([{ name: t.common.home, path: p("home") }, { name: title, path }]),
        ]}
      />
      <PageHero eyebrow={t.blogSection.eyebrow} title={title} intro={t.blogSection.sub} crumbs={[{ name: t.nav.blog, to: path }]} />
      <section className="container-dv py-16 lg:py-20">
        <RevealStagger className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {ARTICLES.map((ar) => (
            <RevealItem key={ar.key}>
              <ArticleCard article={ar} />
            </RevealItem>
          ))}
        </RevealStagger>
      </section>
      <CTABand />
    </>
  );
}
